import { useSafeAreaPadding } from '@/hooks/useSafeAreaPadding';
import { Button } from '@components/Button/Button';
import { Ionicons } from '@expo/vector-icons';
import type { ReactElement } from 'react';
import { Image, Modal } from 'react-native';
import { SizableText, useTheme, XStack, YStack } from 'tamagui';

interface AssetPreviewModalProps {
  previewUrl: string | null;
  previewName: string;
  onClose: () => void;
}

export const AssetPreviewModal = ({
  previewUrl,
  previewName,
  onClose,
}: AssetPreviewModalProps): ReactElement => {
  const padding = useSafeAreaPadding();
  const theme = useTheme();

  return (
    <Modal
      visible={Boolean(previewUrl)}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <YStack
        backgroundColor="$background"
        paddingTop={padding.topPadding}
        paddingBottom={padding.bottomPadding}
        paddingHorizontal="$true"
        gap="$true"
        height="100%"
      >
        <XStack alignItems="center" justifyContent="space-between">
          <SizableText fontFamily="$bold" numberOfLines={1} flex={1}>
            {previewName}
          </SizableText>
          <Button
            variant="ghost"
            icon={<Ionicons name="close" size={20} color={theme.color?.val} />}
            onPress={onClose}
          />
        </XStack>
        {previewUrl ? (
          <Image
            source={{ uri: previewUrl }}
            resizeMode="contain"
            style={{ width: '100%', height: '100%' }}
          />
        ) : null}
      </YStack>
    </Modal>
  );
};
